import React, { useState } from 'react'
import { getEventThumbnail } from '../../utils/eventImageUtils'

/**
 * Flyer thumbnail for a search result.
 *
 * Search results are otherwise three lines of grey text, and picking the right
 * "Bass Canyon" out of several years is a visual job — the flyer is what people
 * actually recognise.
 *
 * Falls back to a placeholder rather than collapsing, so the result rows stay
 * on a single grid and don't jump as images load.
 */
const SearchResultThumb = ({ event, size = 'md' }) => {
  const [failed, setFailed] = useState(false)
  const { src, type } = getEventThumbnail(event)

  const dimensions = size === 'sm' ? 'w-12 h-12' : 'w-16 h-16'

  const frame = `${dimensions} rounded-lg overflow-hidden flex-shrink-0 border border-white/15 bg-white/5 flex items-center justify-center`

  // PDF flyers are served as downloads, not inline images, so there is nothing
  // to render — badge them instead of showing a broken image.
  if (type === 'pdf') {
    return (
      <div className={frame} title="Flyer is a PDF">
        <span className="text-xl" role="img" aria-label="PDF flyer">📄</span>
      </div>
    )
  }

  if (!src || failed) {
    return (
      <div className={frame}>
        <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    )
  }

  return (
    <div className={`${frame} relative`}>
      <img
        src={src}
        alt=""
        loading="lazy"
        // A dead upload path or an expired external URL should degrade to the
        // placeholder, not leave a broken-image glyph in the list.
        onError={() => setFailed(true)}
        className="w-full h-full object-cover"
      />
      {type === 'flyer' && (
        <span
          className="absolute bottom-0 right-0 bg-black/70 text-[9px] leading-none px-1 py-0.5 rounded-tl text-purple-200"
          title="Event flyer"
        >
          📄
        </span>
      )}
    </div>
  )
}

export default SearchResultThumb
